import React from 'react';
import Files from 'react-files'

import Image from "../../components/brews/Image";

import GlobalData from '../../context/globaldata';

class Images extends React.Component {
  static contextType = GlobalData;

  onFilesChange = (files) => {
    console.log(files);

    files.forEach(image => {

      if(image.size <= 2000000) {
        this.props.addImage(
          {
            attachment: image,
            uploading: true,
            progress: 0
          }
        );
      }
    });
  };

  onFilesError = (error, image) => {
    if(error.code === 2) {
      this.context.addNotification('Error', `You are trying to upload an image that is ${ image.sizeReadable }, the filesize limit is 2MB`, 'danger', 'right', 'bottom-right');
    }
    console.log('error code ' + error.code + ': ' + error.message)
  };

  handleImageLoaded = (imageRef) => {
    this.props.updateImage(imageRef, 'attachment', false);
  };

  render() {
    return (
      <div className="brew-images">
        <h1 className="brew-images__heading">Images</h1>
        <div className="brew-images__blocks">
          <ul className="brew-images__list">
            { this.props.brewImages &&
              this.props.brewImages.map(image =>
                <li className="brew-images__item" key={ image.refPath ? image.refPath : image.refPath }>
                  <div className="brew-images__delete" onClick={ () => this.props.deleteImage(image.refPath) }>
                    <i className="material-icons">close</i>
                  </div>
                  <a href={ image.url } target="_blank" rel="noopener noreferrer">
                    <Image image={ image } handleImageLoaded={ this.handleImageLoaded }/>
                  </a>
                </li>
              )
            }
            <li className="brew-images__dropzone">
              <Files
                className="images-dropzone"
                onChange={ this.onFilesChange }
                onError={ this.onFilesError }
                accepts={ ['image/png', 'image/jpeg'] }
                multiple
                maxFiles={ 10 }
                minFileSize={ 0 }
                maxFileSize={ 2000000 }
                clickable
              >
                <div className="images-dropzone__icon">
                  <i className="material-icons">cloud_upload</i>
                </div>
                <div className="images-dropzone__label">
                  <p>Drop files or <span>browse</span></p>
                  <small>Size limit is 2MB</small>
                </div>
              </Files>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default Images;
